var $2b9e50ee093c0349$exports = {};
$2b9e50ee093c0349$exports = {
    "collapse": `\u{6298}\u{308A}\u{305F}\u{305F}\u{3080}`,
    "expand": `\u{5C55}\u{958B}`
};


export {$2b9e50ee093c0349$exports as default};
//# sourceMappingURL=ja-JP.module.js.map
